import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import JobsContent from "../ones/JobsContent";

export default function JobsLanding() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await appContext.getAllJobPosts();
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <section
        className="page-hero text-white"
        style={{
          backgroundImage:
            "linear-gradient(120deg, rgba(18,60,140,0.92), rgba(18,60,140,0.62))",
        }}
      >
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-up">
              <p className="about-tag bg-light text-dark d-inline-flex align-items-center mb-3">
                TEF Careers
              </p>
              <h1 className="font-bold display-5 mb-3">Job Posts</h1>
              <p className="lead mb-0">
                Explore current openings and opportunities at Tanzania Editors'
                Forum.
              </p>
            </div>
            <div
              className="col-lg-4 text-lg-end mt-4 mt-lg-0"
              data-aos="fade-left"
            >
              <button
                className="btn btn-light btn-rounded btn-padded shadow-sm"
                onClick={() => appContext.navTo({ item: "about_us" })}
              >
                About TEF
              </button>
            </div>
          </div>
        </div>
      </section>

      <JobsContent />
      <Footer />
    </>
  );
}
